export default __webpack_public_path__ + "static/media/guy-with-glasses-unplug.24269d6d.png";